import React from 'react';
import { Tabs as BaseTabs, TabsProps } from 'antd';

const Tabs = (props: TabsProps) => <BaseTabs {...props} />;

Tabs.TabPane = BaseTabs.TabPane;
export default Tabs;
